"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityDocumentDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class OpportunityDocumentDto {
    constructor(documentId) {
        this.documentId = documentId;
    }
}
exports.OpportunityDocumentDto = OpportunityDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the document",
        example: 102,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Document ID must be a valid number" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDocumentDto.prototype, "documentId", void 0);
